(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;

  var CONFIG = window.ThemeAnalytics || {};
  var CURRENCY = CONFIG.currency || 'EUR';
  var LIST_NAME = CONFIG.listName || CONFIG.template || 'page';

  function dataLayer() {
    window.dataLayer = window.dataLayer || [];
    return window.dataLayer;
  }

  function pushEcommerce(eventName, payload) {
    try {
      var queue = dataLayer();
      queue.push({ ecommerce: null });
      queue.push({ event: eventName, ecommerce: payload });
    } catch (error) {
    }
  }

  function toAmount(cents) {
    var value = Number(cents);
    return isFinite(value) ? Math.round(value) / 100 : 0;
  }

  function itemFromLine(line, index) {
    if (!line) return null;

    var item = {
      item_id: String(line.sku || line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      item_brand: line.vendor || '',
      item_category: line.product_type || '',
      item_variant: line.variant_title || '',
      price: toAmount(line.final_price != null ? line.final_price : line.price),
      quantity: Number(line.quantity) || 1
    };

    if (typeof index === 'number') item.index = index;
    return item;
  }

  function itemWithQuantity(line, quantity) {
    var item = itemFromLine(line);
    if (item) item.quantity = quantity;
    return item;
  }

  function itemsValue(items) {
    var total = 0;
    for (var i = 0; i < items.length; i++) {
      total += (Number(items[i].price) || 0) * (Number(items[i].quantity) || 0);
    }
    return Math.round(total * 100) / 100;
  }

  function emitItems(eventName, items) {
    var clean = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i]) clean.push(items[i]);
    }
    if (!clean.length) return;

    pushEcommerce(eventName, {
      currency: CURRENCY,
      value: itemsValue(clean),
      items: clean
    });
  }

  function lineKey(line) {
    return line.key || String(line.variant_id || line.id || '');
  }

  var cartLines = {};

  function indexLines(cart) {
    var map = {};
    var lines = cart && Array.isArray(cart.items) ? cart.items : [];

    for (var i = 0; i < lines.length; i++) {
      map[lineKey(lines[i])] = {
        quantity: Number(lines[i].quantity) || 0,
        line: lines[i]
      };
    }
    return map;
  }

  function has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
  }

  function diffAgainstSnapshot(cart) {
    var next = indexLines(cart);
    var added = [];
    var removed = [];
    var key;

    for (key in next) {
      if (!has(next, key)) continue;
      var before = has(cartLines, key) ? cartLines[key].quantity : 0;
      var gained = next[key].quantity - before;
      if (gained > 0) added.push(itemWithQuantity(next[key].line, gained));
    }

    for (key in cartLines) {
      if (!has(cartLines, key)) continue;
      var after = has(next, key) ? next[key].quantity : 0;
      var lost = cartLines[key].quantity - after;
      if (lost > 0) removed.push(itemWithQuantity(cartLines[key].line, lost));
    }

    cartLines = next;
    return { added: added, removed: removed };
  }

  function emitAddition(lines) {
    var items = [];

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var key = lineKey(line);
      var before = has(cartLines, key) ? cartLines[key].quantity : 0;
      var reported = Number(line.quantity) || 0;
      var delta = reported - before;

      if (delta <= 0) delta = reported;

      items.push(itemWithQuantity(line, delta));
      cartLines[key] = { quantity: Math.max(reported, before + delta), line: line };
    }

    emitItems('add_to_cart', items);
  }

  function currentCartItems() {
    var items = [];

    for (var key in cartLines) {
      if (!has(cartLines, key)) continue;
      items.push(itemWithQuantity(cartLines[key].line, cartLines[key].quantity));
    }
    return items;
  }

  cartLines = indexLines(CONFIG.cart);

  function onCartUpdate(payload) {
    try {
      var data = payload && payload.cartData;
      if (!data) return;

      if (Array.isArray(data.items) && data.item_count !== undefined) {
        var diff = diffAgainstSnapshot(data);
        emitItems('add_to_cart', diff.added);
        emitItems('remove_from_cart', diff.removed);
        return;
      }

      if (Array.isArray(data.items)) {
        emitAddition(data.items);
        return;
      }

      emitAddition([data]);
    } catch (error) {
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  document.addEventListener('theme:cart-lines-added', function (event) {
    try {
      var response = event.detail && event.detail.response;
      var lines = response && Array.isArray(response.items) ? response.items : [];

      emitAddition(lines);
    } catch (error) {
    }
  });

  function emitViewCart() {
    emitItems('view_cart', currentCartItems());
  }

  var drawerIsOpen = false;

  function patchCartDrawer() {
    try {
      var CartDrawerClass = window.customElements && window.customElements.get('cart-drawer');
      if (!CartDrawerClass || !CartDrawerClass.prototype) return;
      if (CartDrawerClass.prototype.__dlViewCartPatched) return;

      var openOriginal = CartDrawerClass.prototype.open;
      var closeOriginal = CartDrawerClass.prototype.close;
      if (typeof openOriginal !== 'function') return;

      CartDrawerClass.prototype.__dlViewCartPatched = true;

      CartDrawerClass.prototype.open = function () {
        var wasOpen = drawerIsOpen || this.classList.contains('active');
        drawerIsOpen = true;

        var result = openOriginal.apply(this, arguments);
        if (!wasOpen) emitViewCart();
        return result;
      };

      if (typeof closeOriginal === 'function') {
        CartDrawerClass.prototype.close = function () {
          drawerIsOpen = false;
          return closeOriginal.apply(this, arguments);
        };
      }
    } catch (error) {
    }
  }

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('cart-drawer').then(patchCartDrawer);
  }

  if (CONFIG.pageType === 'cart') emitViewCart();

  var lastCheckoutPush = 0;

  function emitBeginCheckout() {
    var now = Date.now();
    if (now - lastCheckoutPush < 1500) return;
    lastCheckoutPush = now;

    emitItems('begin_checkout', currentCartItems());
  }

  document.addEventListener('click', function (event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var button = target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]');
      if (!button || button.disabled) return;

      emitBeginCheckout();
    } catch (error) {
    }
  }, true);

  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      if (!form || (form.id !== 'CartDrawer-Form' && form.id !== 'cart')) return;
      if (!event.submitter || event.submitter.name !== 'checkout') return;

      emitBeginCheckout();
    } catch (error) {
    }
  }, true);

  var ATTRIBUTE = 'data-analytics-item';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var pending = {};
  var flushTimer = null;

  function readItem(element) {
    try {
      return JSON.parse(element.getAttribute(ATTRIBUTE));
    } catch (error) {
      return null;
    }
  }

  function listIdFor(element) {
    var section = element.closest('[id^="shopify-section-"]');
    return section ? section.id : 'page';
  }

  function flush() {
    flushTimer = null;

    for (var listId in pending) {
      if (!has(pending, listId)) continue;
      var items = pending[listId];
      delete pending[listId];
      if (!items.length) continue;

      pushEcommerce('view_item_list', {
        currency: CURRENCY,
        item_list_id: listId,
        item_list_name: LIST_NAME,
        items: items
      });
    }
  }

  function queue(element) {
    var item = readItem(element);
    if (!item) return;

    var listId = listIdFor(element);
    if (!pending[listId]) pending[listId] = [];
    pending[listId].push(item);

    if (flushTimer === null) flushTimer = setTimeout(flush, 300);
  }

  var observer = typeof IntersectionObserver === 'function'
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          observer.unobserve(entries[i].target);
          queue(entries[i].target);
        }
      }, { threshold: 0.3 })
    : null;

  function scan() {
    try {
      var cards = document.querySelectorAll('[' + ATTRIBUTE + ']');

      for (var i = 0; i < cards.length; i++) {
        if (seen && seen.has(cards[i])) continue;
        if (seen) seen.add(cards[i]);

        if (observer) observer.observe(cards[i]);
        else queue(cards[i]);
      }
    } catch (error) {
    }
  }

  document.addEventListener('click', function (event) {
    try {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var card = target.closest('[' + ATTRIBUTE + ']');
      if (!card) return;

      var item = readItem(card);
      if (!item) return;

      pushEcommerce('select_item', {
        item_list_id: listIdFor(card),
        item_list_name: LIST_NAME,
        items: [item]
      });
    } catch (error) {
    }
  }, true);

  scan();

  document.addEventListener('shopify:section:load', scan);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      try {
        scan();
      } catch (error) {
      }
    });
  }
})();
